module.exports = __webpack_public_path__ + "img/img_nav_recommend.37685776.svg";